var XMLFile			= require("../xml/XMLFile"),
	Relationships	= require("./Relationships");

/**
 * This class represents an Office Open XML Spreadsheet object
 * that is related to other objects via Relationships. The object
 * manages its Relationships by itself to encapsulate the complexity.
 *
 * A ReferenceNode also provides information about its path so that
 * all relationships that are connected to this ReferenceNode are are
 * relative to its path.
 *
 * @param {Object} oConfig Configuration object that is used by the super class XMLFile
 * @constructor
 */
function ReferenceNode(oConfig) {
	XMLFile.call(this, oConfig);

	this._relatedFiles = [];
	this._relationships = new Relationships(this);

	this.addRelatedFile(this._relationships);
}

ReferenceNode.prototype = Object.create(XMLFile.prototype);
ReferenceNode.prototype.constructor = ReferenceNode;


ReferenceNode.prototype.addRelatedFile = function(oXMLFile) {
	if (!(oXMLFile instanceof XMLFile)) {
		throw new Error("A related file must be of type XMLFile");
	}

	this._relatedFiles.push(oXMLFile);
};

ReferenceNode.prototype.getRelationships = function() {
	return this._relationships;
};

/**
 * Returns an Array of {@link XMLFile} objects that are reference by
 * this {@link ReferenceNode}. The method provides a flat copy of the
 * original data to avoid manipulation.
 *
 * @returns {Array} Array containing referenced files
 */
ReferenceNode.prototype.getRelatedFiles = function() {
	return this._relatedFiles.slice();
};

module.exports = ReferenceNode;